'use client';
import IconItem, { IconItemProps } from './iconItem';
import React from 'react';

interface IconGridProps {
  title: string;
  items: Array<{ iconRef: IconItemProps }>;
}

const IconGrid = ({ title, items }: IconGridProps) => {
  return (
    <div className="flex flex-col gap-3 py-5 bg-white">
      <h3 className="font-bold text-xl text-neutral-900 tracking-[0.8px] uppercase">{title}</h3>
      <div className="grid grid-cols-3 gap-5">
        {items.map((item) => (
          <IconItem
            key={item.iconRef.iconKey}
            iconKey={item.iconRef.iconKey}
            label={item.iconRef.label}
          />
        ))}
      </div>
    </div>
  );
};

export default IconGrid;
